import Cookies from 'js-cookie';
import { COOKIE_CONSENT_NAME, type CookieCategory } from './useGranularCookieConsent';

export function isCategoryAllowed(category: CookieCategory): boolean {
  if (typeof document === 'undefined') return false;
  try {
    const raw = Cookies.get(COOKIE_CONSENT_NAME);
    if (!raw) return false;
    const data = JSON.parse(raw);
    return Array.isArray(data?.settings) && data.settings.includes(category);
  } catch {
    return false;
  }
}

// Lets non-React callers (event helpers, top-level useEffects) drop dataLayer
// pushes when the Qmee user hasn't accepted marketing cookies. Other tenants
// have no banner today and pass through unchanged.
export function isQmeeMarketingAllowed(): boolean {
  if (process.env.NEXT_PUBLIC_TENANT !== 'qmee') return true;
  return isCategoryAllowed('ads');
}
